import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-multiple',
  templateUrl: './pdf-find-multiple.component.html',
})
export class PdfFindMultipleComponent {}
